import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    background: theme.palette.bg.main,
    margin: '-32px',
  },
  tabContainer: {
    padding: theme.spacing(0, 5),
    borderBottom: `1px solid ${theme.palette.labraV2BoxShadow.dark}`,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
}))
